import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Link, { A } from 'components/common/Link/Link'
import Button from 'components/common/Button/Button'
import { SERVICES_PAGE, STORE_LOCATOR_PAGE } from 'constant'

const NoResultComponent = ({
  handlePhoneLinkClick,
  handleShopTires,
  heading,
  myStore,
  storePhoneNumber,
  formattedStorePhoneNumber
}) =>
  <Table>
    <Heading data-at-globalsearch-heading>{ heading }</Heading>
    <Caption data-at-globalsearch-caption>There are &quot;0&quot; results that match your search.</Caption>
    <NoResults>
      Make sure all words are spelled correctly and try again.
    </NoResults>
    {myStore ?
      <NoResults>
        Shop our services using the buttons below or contact your store at
        <Media.Desktop>
          <PhoneNumber data-at-savedlocation-phone> { formattedStorePhoneNumber } </PhoneNumber>
        </Media.Desktop>
        <Media.Mobile>
          <A href={ `tel:+1${storePhoneNumber}` } anchor onClick={ handlePhoneLinkClick }>
            <PhoneNumber> { formattedStorePhoneNumber } </PhoneNumber>
          </A>
        </Media.Mobile>
        for assistance.
      </NoResults> :
      <NoResults>
        Shop our services using the buttons below or contact your neighborhood Big O Tires store for assistance.
      </NoResults>
    }
    <ButtonWrapper>
      <CustomButton
        full="mobile"
        narrow
        onClick={ handleShopTires }>
        Shop Tires
      </CustomButton>
      <Link
        button
        to={ SERVICES_PAGE }
        full="mobile">
        Shop Services
      </Link>
      {!myStore && <Link
        button
        to={ STORE_LOCATOR_PAGE }
        full="mobile">
        Choose a Store
      </Link>}
    </ButtonWrapper>
  </Table>

NoResultComponent.propTypes = {
  formattedStorePhoneNumber: PropTypes.string,
  handlePhoneLinkClick: PropTypes.func,
  handleShopTires: PropTypes.func,
  heading: PropTypes.string,
  myStore: PropTypes.shape(),
  storePhoneNumber: PropTypes.string
}

export default NoResultComponent

const Table = styled.div`
  ${Media.desktop`
    display: table;
    width: 100%;
  `}
  ${Media.mobile`
    padding: 0 16px;
  `}
`

const Heading = styled.h1`
  margin: 30px 0 18px;
  text-transform: uppercase;
  ${Mixin.font.GothamBold(34, 600)}
  ${Media.desktop`
    margin-top: 40px;
  `}
  ${Media.mobile`
    margin-bottom: 40px;
  `}
`

const Caption = styled.h2`
  text-align: center;
  margin: 1em 0;
  ${Mixin.font.GothamBold(26, 600)}
`

const NoResults = styled.p`
  text-align: center;
  font-size: 18px;
  margin: 0.6em 0;
`

const PhoneNumber = styled.span`
  font-size: 18px;
  white-space: nowrap;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  ${Mixin.responsive('margin', '25px 0', '30px 0')}
  ${Media.mobile`
    flex-direction: column;
  `}
`
const CustomButton = styled(Button)`
  min-width: 160px;

  &:hover {
    cursor: pointer;
  }
`
